// Pure (Howler-free) on purpose: the shared test mock for soundController
// re-exports this real implementation instead of hand-duplicating it, so the
// mock can never drift from production behaviour.
export const calculatePercentage = (currentTime: number, duration?: number): number => {
	if (duration) {
		const progress = Math.round((currentTime / duration) * 100)
		// An undefined/NaN currentTime (audio loaded but never started) or an
		// Infinity input must not leak NaN/Infinity into callers — they feed this
		// straight into controlled inputs and CSS.
		return Number.isFinite(progress) ? progress : 0
	}
	return 0
}
